import { useEffect, useState } from 'react';

const usePagination = <T>(
  data: T[],
  initialPageNumber = 1,
  postsPerPage = 10,
  currentTab?: number
) => {
  const [currentPage, setCurrentPage] = useState(initialPageNumber);
  const [numOfPagePosts] = useState(postsPerPage);

  const indexOfLastPost = currentPage * numOfPagePosts;
  const indexOfFirstPost = indexOfLastPost - numOfPagePosts;
  const slicedPosts = data?.slice(indexOfFirstPost, indexOfLastPost);
  const shownData = currentPage * numOfPagePosts;

  const dataLength = data.length;

  useEffect(() => {
    if (currentTab) {
      setCurrentPage(initialPageNumber);
    }
  }, [currentTab]);

  return {
    slicedPosts,
    currentPage,
    setCurrentPage,
    numOfPagePosts,
    dataLength,
    shownData
  };
};

export default usePagination;
